import { ErrorIcon, Typography } from '@iheartjane/reefer';

import styles from './storeSwitcherError.module.css';

export function StoreSwitcherError({ error }: { error: string }) {
  return (
    <div className={styles['errorContainer']}>
      <ErrorIcon className={styles['errorIcon']} />
      <Typography
        ml={16}
        variant="small-body-semibold"
        className={styles['errorText']}
      >
        {error}
      </Typography>
    </div>
  );
}
